import { gql } from '@apollo/client';

export const CURRENT_USER_PERMISSIONS_QUERY_BASE = `
  query {
    currentUserPermissions {
      resourceName
      id
      name
    }
  }
`;

export const CURRENT_USER_PERMISSIONS_QUERY = gql`${CURRENT_USER_PERMISSIONS_QUERY_BASE}`;
